import React from "react";
import logger from "logger";
import { getStyleJSON, TROOP_NAMES } from "Utils/Common";
import AngSelect from "Common/Angular/AngSelect";

export const TroopTypeSelector = (props) => {
  const { label, param, taskConfig, setValue } = props;
  const troopNamesForThisrace = {};
  for (var prop in TROOP_NAMES) {
    if (TROOP_NAMES.hasOwnProperty(prop)) {
      if (prop.indexOf("u") === 0) {
        troopNamesForThisrace[prop] = TROOP_NAMES[prop];
      }
    }
  }
  return (
    <div style={{ padding: "7px" }}>
      <div>{label}</div>
      <div style={getStyleJSON("padding-top: 10px;")}>
        <AngSelect
          styleStr="width: 200px;"
          ng-model={taskConfig[param]}
          options={troopNamesForThisrace
            ? Object.keys(troopNamesForThisrace).map((key) => {
              const value = troopNamesForThisrace[key];
              return {
                label: value,
                value: key,
              };
            })
            : []}
          onChange={({ value }) => {
            setValue({ target: { value } }, param);
          }} />
      </div>
    </div>
  );
};
